// Restrained abstract discipline-network motif used behind governance cards.
// Suggests connected disciplines converging on a central problem — not hierarchy.
export function NetworkMotif({ className = "" }) {
  const nodes = [
    [20, 22],
    [82, 16],
    [50, 46],
    [16, 74],
    [86, 70],
    [56, 90],
  ];
  const links = [
    [0, 2], [1, 2], [2, 3], [2, 4], [2, 5], [3, 5], [4, 5], [0, 1],
  ];
  return (
    <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" className={className}>
      <g stroke="currentColor" strokeWidth="0.5">
        {links.map(([a, b], i) => (
          <line key={i} x1={nodes[a][0]} y1={nodes[a][1]} x2={nodes[b][0]} y2={nodes[b][1]} />
        ))}
      </g>
      <g fill="currentColor">
        {nodes.map(([x, y], i) => (
          <circle key={i} cx={x} cy={y} r={i === 2 ? 2.6 : 1.6} />
        ))}
      </g>
    </svg>
  );
}
